import React, { useEffect, useState } from 'react';
import './RoleServiceMap.css';
import axios from 'axios';
import Select from "react-select";
import { useNavigate } from 'react-router-dom';
import { getRoles } from '../../../services/employeeCreationService';
import { assignServicesToRole, getServicesByRoleId } from '../../../services/loginService';

const RoleServiceMap = () => {
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [services, setServices] = useState([]);
const navigate=useNavigate();
  // Fetch roles
  useEffect(() => {
    const fetchRoles = async () => {
      try {
       // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/role`);
       const data= await getRoles();
        const roleOptions = data.map(role => ({
          value: role.roleId,
          label: role.roleName
        }));
        setRoles(roleOptions);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };
    fetchRoles();
  }, []);

  // Fetch services when a role is selected
  useEffect(() => {
    const fetchServices = async () => {
      if (!selectedRole) return;

      try {
       // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/role-service-mapping/role/${selectedRole.value}/services-status`);
         const data = await getServicesByRoleId(selectedRole.value);
        setServices(data);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchServices();
  }, [selectedRole]);
  /*   
  It will working single directions
*/
  // Toggle checkbox assignment
  // const handleCheckboxChange = (serviceId) => {
  //   const toggleAssigned = (items) =>
  //     items.map((item) => {
  //       if (item.serviceId === serviceId) {
  //         return { ...item, assigned: !item.assigned };
  //       }
  //       // if (item.childServices?.length > 0) {
  //       //   return {
  //       //     ...item,
  //       //     childServices: toggleAssigned(item.childServices),
  //       //   };
  //       // }
  //       // return item;
  //         if (item.childServices?.length > 0) {
  //       const updatedChildren = toggleAssigned(item.childServices);

  //       // If any child is assigned, parent should also be assigned
  //       const parentAssigned = updatedChildren.some(c => c.assigned);

  //       return {
  //         ...item,
  //         assigned: parentAssigned || item.assigned, // keep true if already selected
  //         childServices: updatedChildren
  //       };
  //     }
  //     return item;
  //     });

  //   setServices((prev) => toggleAssigned(prev));
  // };
//   const handleCheckboxChange = (serviceId) => {
//   const updateAssigned = (items) => {
//     return items.map((item) => {
//       if (item.serviceId === serviceId) {
//         // Toggle current service
//         const newAssigned = !item.assigned;

//         // If toggling a parent, cascade to all children
//         const cascadeChildren = (children) =>
//           children.map(child => ({
//             ...child,
//             assigned: newAssigned,
//             childServices: child.childServices ? cascadeChildren(child.childServices) : []
//           }));

//         return {
//           ...item,
//           assigned: newAssigned,
//           childServices: item.childServices ? cascadeChildren(item.childServices) : []
//         };
//       }

//       if (item.childServices?.length > 0) {
//         const updatedChildren = updateAssigned(item.childServices);

//         // Parent assigned if ANY child assigned
//         const parentAssigned = updatedChildren.some(c => c.assigned);

//         return {
//           ...item,
//           assigned: parentAssigned || item.assigned && serviceId !== item.serviceId,
//           childServices: updatedChildren
//         };
//       }

//       return item;
//     });
//   };

//   setServices((prev) => updateAssigned(prev));
// };

/*   
  It will working two directions
*/
// const handleCheckboxChange = (serviceId) => {
//   const toggleAssigned = (items) => {
//     return items.map((item) => {
//       if (item.serviceId === serviceId) {
//         // Toggle this service
//         return { ...item, assigned: !item.assigned };
//       }

//       if (item.childServices?.length > 0) {
//         // Recursively update children
//         const updatedChildren = toggleAssigned(item.childServices);

//         // Check if any child is still assigned
//         const anyChildAssigned = updatedChildren.some(c => c.assigned);

//         return {
//           ...item,
//           // Parent gets assigned if any child is assigned
//           assigned: anyChildAssigned,
//           childServices: updatedChildren
//         };
//       }
      
//       return item;
//     });
//   };

//   setServices((prev) => toggleAssigned(prev));
// };

/*   
  It will working all directions
*/
const handleCheckboxChange = (serviceId) => {
  const toggleAssigned = (items, parentToggled = null) => {
    return items.map((item) => {
      // If this is the one clicked
      if (item.serviceId === serviceId) {
        const newAssigned = !item.assigned;

        // If parent clicked → cascade down to all children
        const cascadeChildren = (children) =>
          children.map(child => ({
            ...child,
            assigned: newAssigned,
            childServices: child.childServices
              ? cascadeChildren(child.childServices)
              : []
          }));

        return {
          ...item,
          assigned: newAssigned,
          childServices: item.childServices
            ? cascadeChildren(item.childServices)
            : []
        };
      }

      // If this is a child in a subtree being updated
      if (item.childServices?.length > 0) {
        const updatedChildren = toggleAssigned(item.childServices, serviceId);

        // Case 1 & 2: parent assigned if ANY child is assigned
        const anyChildAssigned = updatedChildren.some(c => c.assigned);

        return {
          ...item,
          assigned: anyChildAssigned,
          childServices: updatedChildren
        };
      }

      return item;
    });
  };

  setServices((prev) => toggleAssigned(prev));
};

const formatServiceName = (name) => {return name.replace(/([a-z])([A-Z])/g, "$1 $2");};
  // Recursive render

  const renderServiceRows = (items, level = 0, indexRef = { current: 1 }) => {
    return items.flatMap((service) => {
      const row = (
        <tr key={service.serviceId}>
          <td>{indexRef.current++}</td>
          <td className={`indent-${level}`}>{formatServiceName(service.serviceName)}</td>
          <td>
            <input
              type="checkbox"
              checked={service.assigned}
              onChange={() => handleCheckboxChange(service.serviceId)}
            />
          </td>
        </tr>
      );

      const children = service.childServices?.length
        ? renderServiceRows(service.childServices, level + 1, indexRef)
        : [];

      return [row, ...children];
    });
  };

  // Get assigned service IDs
  const getAssignedServiceIds = (items) => {
    const result = [];
    const traverse = (list) => {
      list.forEach((service) => {
        if (service.assigned) {
          result.push(service.serviceId);
        }
        if (service.childServices?.length > 0) {
          traverse(service.childServices);
        }
      });
    };
    traverse(items);
    return result;
  };

  // Save handler
  const handleSave = async () => {
    if (!selectedRole) {
      alert("Please select a role first.");
      return;
    }

    const assignedServiceIds = getAssignedServiceIds(services);

    try {
     
      //    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/role-service-mapping/${selectedRole.value}/assign-services`,assignedServiceIds,
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
       await assignServicesToRole(selectedRole.value, assignedServiceIds);
      alert("Services assigned successfully!");
    } catch (error) {
      console.error("Error saving services:", error);
      alert("Failed to save services.");
    }
  };
  const homeNavigate=()=>{
navigate("/home")
  }

  return (
    <div className="role-service">
      <h2 className='role-service-title'>Role Service Map</h2>

      {/* Role Dropdown */}
      <div className="role-service-image">
        <div className={`role-service-input-group ${selectedRole ? "filled" : ""}`}>
          <Select
            options={roles}
            value={selectedRole}
            onChange={setSelectedRole}
            isClearable
            placeholder=""
            className="user-select"
            classNamePrefix="user-select"
          />
          <label>Select Role</label>
        </div>
      </div>

      {/* Services Table */}
      <table className="role-service-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Service Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>{renderServiceRows(services)}</tbody>
      </table>

      {/* Buttons */}
      <div className='role-service-map'>
        <button onClick={handleSave} className='roleservice-sub-btn'>
          Save
        </button>
        <button  className='roleservic-cancel-btn' onClick={homeNavigate}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default RoleServiceMap;
